 
  <div class="row">
    <div class="col-lg-12">

      <iframe style="width:100%;height:50rem" src="http://localhost/ReportServer/Pages/ReportViewer.aspx?%2fReport%2fReport1&rs:Command=Render&rs:embed=true" frameborder="0" allowFullScreen="true"></iframe>
    </div>

  </div>
